import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { setUserData } from './actions/auth';
import { getInventoryFilters } from './actions/inventory';
import { getProfile } from './actions/profile'
import { getCompanies, getCompanyRqTypes } from './actions/companies';
import { getUserRoles, setIntsallerList } from './actions/installer';
import { getBillingCompanies } from './actions/vehicles';
import { appImages, appTitle } from './constants';
import { userAllowedPages } from './actions/auth';
import AuthRoutes from './app/routes/authRoutes';
import UnAuthRoutes from './app/routes/unAuthRoutes';
import LoadingElement from './Common/LoadingElement';
import { decodeAndRead } from './utils';
import './App.css';



const AuthWithLoading = ({ allowedPages }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, [])

  return loading ? <LoadingElement /> : <AuthRoutes allowedPages={allowedPages} />
}

function App() {
  const userDetails = useSelector(({ userDetails }) => userDetails, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    const userData = decodeAndRead("userData");
    if (userData?.id) {
      dispatch(userAllowedPages(userData.id));
      dispatch(getProfile());
      setUserData(dispatch, userData);
      dispatch(getInventoryFilters());
      dispatch(getCompanies());
      dispatch(setIntsallerList());
      dispatch(getCompanyRqTypes());
      dispatch(getBillingCompanies());
      dispatch(getUserRoles());
    }
  }, [userDetails?.token]);

  return (
    <BrowserRouter basename={"/"}>
      <title>{appTitle}</title>
      <link rel="icon" type="image/svg+xml" href={appImages.logo} />
      {userDetails?.token ? <AuthWithLoading allowedPages={userDetails?.allowedPageNames} /> : <UnAuthRoutes />}
      <ToastContainer position='bottom-right' />
    </BrowserRouter>
  );
}

export default App;